import { render, staticRenderFns } from "./BindsSnackbarContent.vue?vue&type=template&id=1dfd8eae&functional=true&"
import script from "./BindsSnackbarContent.vue?vue&type=script&lang=js&"
export * from "./BindsSnackbarContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports